import React, { Component } from "react";
import { connect } from "react-redux";
import { extractVendorStatus } from "../../../OnboardingContainer";
import { updateServiceData } from "../../../../../redux/serviceSlice";
import { updateCommonInfo } from "../../../../../redux/commonSlice";

import DownloadRenderer from "../DownloadRenderer/DownloadRederer";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "./DownloadDocument.css";
import { httpGetVendorStatusDetails } from "../../../../../service/httpClient";

class DownloadDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          field: "fileType",
          headerName: "Document Category",
          sortable: true,
          filter: true,
          width: 150,
          resizable: true,
          lockVisible: true,
          suppressMovable: true,
        },
        {
          field: "documentName",
          headerName: "Document Name",
          sortable: true,
          filter: true,
          width: 220,
          resizable: true,
          lockVisible: true,
          suppressMovable: true,
        },
        {
          field: "updatedAt",
          headerName: "Date",
          sortable: true,
          filter: true,
          width: 140,
          resizable: true,
          lockVisible: true,
          suppressMovable: true,
        },
        {
          field: "email",
          headerName: "User",
          sortable: true,
          filter: true,
          width: 150,
          resizable: true,
          lockVisible: true,
          suppressMovable: true,
          cellRenderer: function(params) {
            const { value = "" } = params || {};
            return value?.toLowerCase();
          },
        },
        {
          field: "documentPath",
          headerName: "Actions",
          width: 100,
          colId: "documentPath",
          lockVisible: true,
          suppressMovable: true,
          cellRendererFramework: DownloadRenderer,
          cellRendererParams: {
            fetchData: this.props.fetchData,
            setFetching: this.props.setFetching,
            dataRefreshHandler: this.updateStore,
          },
        },
      ],
      overlayNoRowsTemplate: "No Documents Yet",
    };
  }
  updateStore = (vendorId) => {
    httpGetVendorStatusDetails(vendorId)
      .then((res) => {
        const { mutatedVendorStatus } = extractVendorStatus(
          this.props.vendorDetails.status,
          res.data
        );
        const { updateServiceData, updateCommonInfo } = this.props;
        updateServiceData({ vendorStatus: res.data });
        updateCommonInfo({ boardingStatuses: mutatedVendorStatus });
      })
      .catch((error) => {
        console.log('"Error in Document Center Page: "', error);
      });
  };

  onGridReady = (params) => {
    if (!this.props.isFetching && this.props.documentList.length > 0) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();

      this.updateColDefs();

      // Set grid dynamically if documents are present
      // Used for disabling action column
      this.gridApi.setColumnDefs(
        this.state.columnDefs.map((item) => {
          if (item.field !== "documentPath") {
            return {
              ...item,
              filter: !this.props.disabled,
              sortable: !this.props.disabled,
            };
          } else {
            return {
              ...item,
              cellRendererParams: {
                ...item.cellRendererParams,
                disableAction: this.props.disabled,
              },
            };
          }
        })
      );
    }
  };

  updateColDefs = () => {
    const indexOfAction = this.state.columnDefs.findIndex(
      (item) => item.field === "documentPath"
    );
    if (indexOfAction > -1) {
      const columnDefs = [...this.state.columnDefs];
      const item = { ...columnDefs[indexOfAction] };
      columnDefs[indexOfAction] = {
        ...item,
        cellRendererParams: {
          ...item.cellRendererParams,
          duns: this.props.duns,
        },
      };

      this.setState({ columnDefs });
    }
  };

  render() {
    return (
      <div className="ag-theme-balham table">
        <AgGridReact
          columnDefs={
            this.props.documentList.length === 0
              ? this.state.columnDefs
              : undefined
          } // Set default headers if no documents have been uploaded.
          rowData={this.props.documentList}
          rowSelection="multiple"
          overlayNoRowsTemplate={
            this.props?.documentList?.length === 0 &&
            this.state.overlayNoRowsTemplate
          }
          onGridReady={(params) => this.onGridReady(params)}
        />
        <div className="document-static-text">
          <div>
            <p className="font-weight-bold">Merchants:</p>
          </div>
          <p>
            Document templates and instructions can be found via this link:{" "}
            <a
              className="linkStyle"
              href="http://mymacys.net/sites/merchandising/v2c/Pages/default.aspx"
            >
              http://mymacys.net/sites/merchandising/v2c/Pages/default.aspx
            </a>
          </p>
          <div>
            <p className="font-weight-bold">Vendors:</p>
          </div>
          <p>
            In order for a vendor’s submission to enter our Vendor Integration &
            Testing Pipeline, a vendor may need to submit multiple documents on
            this page. All submitted documents require approval by a Macy’s Inc.
            merchant and our Accounts Payable team.
          </p>
          <p>
            Although required documents vary by vendor type, if you are an
            entirely new vendor and have never done business with Macy’s Inc., a
            vendor will need to submit the following documents for approval by
            Accounts Payable to create a vendor number and DUNS (if you don’t
            already have one):
          </p>
          <ul>
            <li>Compliance Letter</li>
            <li>Continuing Guaranty</li>
            <li>Blank Invoice or Company Letterhead</li>
            <li>
              Minority/Women-Owned Business Documentation (if applicable*)
            </li>
          </ul>
          <p>
            Additionally, below are the required documents for a vendor that
            plans to participate in direct fulfillment (sometimes referred to as
            VDF, V2C, or Drop Ship):
          </p>
          <ul>
            <li>Signed Contract**</li>
            <li>UPS Shipping Information***</li>
          </ul>
          <p>
            Once your merchant contact reviews your submission, they will
            contact you with further instructions on required documentation.
          </p>
          <p>
            *Minority/Women-Owned Business Documentation is only required for
            new vendors that selected “Yes” on the Company Details page.
          </p>
          <p>
            **A contract will be sent to vendors by a merchant through Adobe
            Sign. Once signed by both sides (fully executed), either the
            merchant or vendor can upload it here.
          </p>
          <p>
            ***A UPS shipping form will be provided to vendors by a merchant.
            Vendors must complete the form and upload it here.
          </p>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateServiceData: (data) => dispatch(updateServiceData(data)),
    updateCommonInfo: (data) => dispatch(updateCommonInfo(data)),
  };
};

export default connect(null, mapDispatchToProps)(DownloadDocument);
